import ContactDetailsSticky from './contact-details-sticky';
import ContactDetailsPlatinumStickyReviews from './contact-details-sticky-reviews';

export { ContactDetailsSticky, ContactDetailsPlatinumStickyReviews };
export default ContactDetailsSticky;
